import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const CkEditorContentStyles = makeStyles((theme: Theme) =>
  createStyles({
    hyphenate: {
      wordBreak: 'break-word',
    },
    ckeditorMedia: {
      margin: '6% 0 1.5% 0',
      width: '100%',
      height: '162px',
      [theme.breakpoints.up('sm')]: {
        height: '294px',
      },
      [theme.breakpoints.up('md')]: {
        height: '302px',
      },
      [theme.breakpoints.up('lg')]: {
        height: '355px',
      },
      [theme.breakpoints.up('xl')]: {
        height: '470px',
      },
    },
  }),
);

export default CkEditorContentStyles;
